export default function Footer({ t, scrollTo }) {
  const links = [
    { id: "manifesto", label: t.nav.manifesto },
    { id: "services", label: t.nav.services },
    { id: "corridors", label: t.nav.corridors },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <footer
      data-testid="footer"
      className="relative overflow-hidden bg-obsidian py-16 text-cream"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="inline-block rounded-sm bg-cream p-3">
              <img
                src="/logo.jpeg"
                alt="Hindu Kush"
                className="h-14 w-auto mix-blend-multiply"
              />
            </div>
            <p className="mt-6 font-serif text-lg italic text-cream/80">
              {t.footer.tagline}
            </p>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-cream/40">
              {t.footer.pledge}
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.28em] text-gold">
              {t.footer.explore}
            </p>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="text-sm text-cream/60 transition-colors hover:text-gold"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.28em] text-gold">
              {t.footer.contactTitle}
            </p>
            <p className="text-sm leading-relaxed text-cream/60">
              45 Rue Boursault
              <br />
              75017 Paris — France
            </p>
            <a
              href="tel:+971507726069"
              data-testid="footer-phone"
              className="mt-3 block text-sm text-cream/60 transition-colors hover:text-gold"
            >
              +971 50 772 6069
            </a>
            <a
              href="mailto:brightneck17@gmail.com"
              data-testid="footer-email"
              className="mt-1 block text-sm text-cream/60 transition-colors hover:text-gold"
            >
              brightneck17@gmail.com
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-7 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-cream/35">
            {t.footer.rights}
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-cream/35">
            Şimdi Senden · Paris — Istanbul — Dubai — Singapore
          </p>
        </div>
      </div>
    </footer>
  );
}
